var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { AbstractComponent } from 'gp-admin-abstract';
var AlertComponent = /** @class */ (function (_super) {
    __extends(AlertComponent, _super);
    function AlertComponent(el) {
        var _this = _super.call(this, el) || this;
        _this.el = el;
        /**
         * Текст на кнопке "Отмена"
         *
         * @type {string}
         */
        _this.buttonCancelText = 'Отмена';
        /**
         * Текст на кнопке действия
         *
         * @type {string}
         */
        _this.buttonActionText = 'Удалить';
        /**
         * Текст в заголовке
         */
        _this.title = 'Удалить статью?';
        /**
         * Событие при клике на Действие (Удалить)
         *
         * @type {EventEmitter<boolean>}
         */
        _this.actionClick = new EventEmitter();
        /**
         * Событие при клике на Отменить
         *
         * @type {EventEmitter<boolean>}
         */
        _this.cancelClick = new EventEmitter();
        return _this;
    }
    AlertComponent.prototype.action = function () {
        this.show();
        this.actionClick.emit(true);
    };
    AlertComponent.prototype.cancel = function () {
        this.hide();
        this.cancelClick.emit(true);
    };
    /**
     * Закрытие alert
     */
    AlertComponent.prototype.hide = function () {
        this.popup.hide();
    };
    /**
     * Показать alert
     */
    AlertComponent.prototype.show = function () {
        this.popup.show();
    };
    AlertComponent.decorators = [
        { type: Component, args: [{
                    selector: 'gp-alert',
                    template: "\n<gp-popup #popup>\n\n  <div class=\"modal-form__content margin--bottom-2 text--align-center\">\n    <span class=\"gp-alert__text\">{{title}}</span>\n  </div>\n\n  <footer class=\"modal-form__footer flex flex--content-center\">\n\n    <gp-button [text]=\"buttonActionText\" (click)=\"action()\" color=\"error\"></gp-button>\n\n    <div class=\"margin--left-1\">\n      <gp-button [text]=\"buttonCancelText\" (click)=\"cancel()\"></gp-button>\n    </div>\n\n  </footer>\n\n</gp-popup>\n",
                    styles: [
                        "@charset \"UTF-8\";\n/**\n * \u041F\u0435\u0440\u0435\u043C\u0435\u043D\u043D\u044B\u0435\n */\n:root {\n  --color-white: white;\n  --color-success: #00afec;\n  --color-warning: #ffb827;\n  --color-error: #f35252;\n  --color-disabled: #dbdbdb;\n  --color-black: black;\n  --color-span: #b5b5b5;\n  --color-span-second: #212121;\n  --color-bg: #f8f8f8;\n  --color-bg-second: #f8f8f8;\n  --color-bg-success: rgba(0, 175, 236, 0.1);\n  --color-bg-warning: var(--color-warning);\n  --color-bg-error: var(--color-error);\n  --color-placeholder: #b5b5b5;\n  --color-border: #dbdbdb;\n  --color-radio-border: #d3d3d3;\n  --font-roboto: 'Roboto', sans-serif;\n  --font-helvetica: 'Helvetica', sans-serif; }\n\n/**\n *\n */\n/**\n * \u0421\u0442\u0438\u043B\u0438 \u0434\u043B\u044F \u043A\u043E\u043C\u043F\u043E\u043D\u0435\u043D\u0442\u0430 \"gp-alert\"\n */\n/deep/ .gp-alert {\n  background-color: rgba(33, 33, 33, 0.8);\n  z-index: 100; }\n  /deep/ .gp-alert__text {\n    font: 1.4rem/2rem \"Roboto\", sans-serif;\n    color: #212121;\n    letter-spacing: 0.03rem; }\n\n.modal-form {\n  position: absolute;\n  padding: 3rem;\n  font-family: \"Roboto\", sans-serif;\n  border: 0.1rem solid #dbdbdb;\n  top: 5rem;\n  left: 50%;\n  -moz-transform: translateX(-50%);\n  -o-transform: translateX(-50%);\n  -ms-transform: translateX(-50%);\n  -webkit-transform: translateX(-50%);\n  transform: translateX(-50%); }\n  .modal-form__header {\n    text-align: center; }\n  .modal-form__title {\n    font: bold 1.4rem/2rem \"Roboto\", sans-serif;\n    letter-spacing: 0.03rem;\n    text-align: center;\n    margin: 0;\n    -webkit-touch-callout: none;\n    -webkit-user-select: none;\n    -khtml-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none; }\n"
                    ]
                },] },
    ];
    /** @nocollapse */
    AlertComponent.ctorParameters = function () { return [
        { type: ElementRef, },
    ]; };
    AlertComponent.propDecorators = {
        'buttonCancelText': [{ type: Input },],
        'buttonActionText': [{ type: Input },],
        'title': [{ type: Input },],
        'actionClick': [{ type: Output },],
        'cancelClick': [{ type: Output },],
        'popup': [{ type: ViewChild, args: ['popup',] },],
    };
    return AlertComponent;
}(AbstractComponent));
export { AlertComponent };
//# sourceMappingURL=alert.component.js.map